import * as React from 'react';
import './ui.css';

/*
 * Panel — a surface/window container. Base for HUD widgets and modals. Replaces
 * the SVG chrome backings (BiddingContainer, Scoreboard/CurrentBid/CurrentAction
 * backgrounds).
 */

interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  /** "hud" = translucent blurred board overlay; "solid" = opaque surface. */
  variant?: 'solid' | 'hud';
  padding?: string | number;
}

export const Panel = React.forwardRef<HTMLDivElement, PanelProps>(
  ({ variant = 'solid', padding, className = '', style, children, ...rest }, ref) => {
    const classes = ['ui-panel', variant === 'hud' ? 'ui-panel--hud' : '', className]
      .filter(Boolean)
      .join(' ');

    return (
      <div ref={ref} className={classes} style={{ padding: padding ?? 16, ...style }} {...rest}>
        {children}
      </div>
    );
  },
);

Panel.displayName = 'Panel';

export default Panel;
